import { Box } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    cursor: 'pointer',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    '@media (hover: hover)': {
      '&:hover': {
        transition: theme.transitions.create('all'),
        opacity: 0.95,
        transform: 'scale(1.01)',
      },
      '&:hover Box': {
        transition: theme.transitions.create('all'),
        color: theme.palette.primary.dark,
      },
    },
  },
}))

interface Props {
  className: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  children?: React.ReactNode
}

const HoverCardContainer: React.FC<Props> = ({ className, onClick, ...props }) => {
  const { classes, cx } = useStyles()
  return (
    <Box className={cx(classes.container, className)} onClick={onClick}>
      {props.children}
    </Box>
  )
}

export default HoverCardContainer
